import { WretchError } from 'wretch/resolver';
export function buildWretchError(message, response) {
    const error = new WretchError(message);
    error.response = response;
    error.status = response.status;
    error.url = response.url;
    return error;
}
//# sourceMappingURL=errorUtils.js.map